import React from "react";
import { Modal, Form, Input, InputNumber } from "antd";
import { DollarOutlined } from "@ant-design/icons";
import { FormInstance } from "antd/lib/form";

interface ManualTransactionModalProps {
  open: boolean;
  txType: "deposit" | "withdrawal";
  selectedAccount: any;
  onCancel: () => void;
  onOk: () => void;
  confirmLoading: boolean;
  form: FormInstance;
}

export const ManualTransactionModal: React.FC<ManualTransactionModalProps> = ({
  open,
  txType,
  selectedAccount,
  onCancel,
  onOk,
  confirmLoading,
  form,
}) => {
  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <DollarOutlined
            className={txType === "deposit" ? "text-green-500" : "text-red-500"}
          />
          <span>
            Manual {txType === "deposit" ? "Deposit" : "Withdrawal"}
          </span>
        </div>
      }
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      confirmLoading={confirmLoading}
      okText={`Record ${txType === "deposit" ? "Deposit" : "Withdrawal"}`}
      okButtonProps={{ danger: txType === "withdrawal" }}
    >
      <div className="mb-4 text-sm text-gray-500 bg-gray-50 p-3 rounded border">
        <div className="flex justify-between mb-1">
          <span>Bank Name:</span>
          <span className="font-semibold text-gray-700">
            {selectedAccount?.bank_name}
          </span>
        </div>
        <div className="flex justify-between">
          <span>Current Balance:</span>
          <span className="font-bold text-green-600">
            LKR{" "}
            {Number(selectedAccount?.balance || 0).toLocaleString("en-US", {
              minimumFractionDigits: 2,
            })}
          </span>
        </div>
      </div>

      <Form form={form} layout="vertical">
        <Form.Item
          name="amount"
          label="Transaction Amount"
          rules={[
            { required: true, message: "Please enter amount" },
            {
              validator: (_, value) =>
                value && value <= 0
                  ? Promise.reject("Amount must be greater than zero")
                  : Promise.resolve(),
            },
          ]}
        >
          <InputNumber
            className="w-full"
            min={0.01}
            precision={2}
            placeholder="0.00"
            formatter={(val) =>
              `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(val) => val!.replace(/\$\s?|(,*)/g, "") as any}
          />
        </Form.Item>

        <Form.Item name="reference_no" label="Reference / Slip Number">
          <Input placeholder="Enter reference transaction number (optional)" />
        </Form.Item>

        <Form.Item name="note" label="Notes / Comments">
          <Input.TextArea
            placeholder="Enter additional notes or reason for transaction"
            rows={3}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
